import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-will-call-confirm-modal',
  templateUrl: './will-call-confirm-modal.component.html',
  styleUrls: ['./will-call-confirm-modal.component.scss'],
})
export class WillCallConfirmModalComponent {
  @Input() isOnline$: Observable<boolean>;
  constructor(
    readonly platformService: PlatformService,
    private modalController: ModalController,
  ) {}

  async dismissModal(confirmation: boolean) {
    await this.modalController.dismiss({ dispatchAction: confirmation });
  }
}
